import { Controller } from '@hotwired/stimulus'

const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000

export default class extends Controller {
  connect() {
    if (!document.body.classList.contains('cookie-consent-dropdown')) return

    const slot = document.getElementById('cookie-consent') ?? this.createSlot()
    if (!slot.contains(this.element)) {
      slot.append(this.element)
      return
    }
    this.element.hidden = false
  }

  createSlot() {
    const slot = document.createElement('div')
    slot.id = 'cookie-consent'
    document.querySelector('header').append(slot)
    return slot
  }

  accept(event) {
    event.preventDefault()
    const expires = new Date(Date.now() + ONE_YEAR_MS).toUTCString()
    document.cookie = `tracking=true;expires=${expires}`
    this.element.querySelectorAll('.cookies').forEach(cookies => { cookies.style.display = 'none' })
    document.querySelectorAll('.navbar').forEach(navbar => { navbar.style.top = '0' })
    document.body.classList.remove('cookie-consent-dropdown')
  }
}
